import { CheckIcon } from "@chakra-ui/icons";
import { Button, Tooltip } from "@chakra-ui/react";
import Select from "../../../shared/components/Select";
import { SandataPlanOfCareItemId } from "../../../shared/schema/schema";
import { UNMAPPED_MARKER } from "../evv-duty-code-mapping.utils";
import { SandataPocMapping, SandataViewProps } from "../sandata-poc-mapping.types";

const isSameSandataItemIds = (a: SandataPlanOfCareItemId[], b: SandataPlanOfCareItemId[]) => {
  if (a.length !== b.length) {
    return false;
  }

  const sortedA = [...a].sort();
  const sortedB = [...b].sort();

  return sortedA.every((value, index) => value === sortedB[index]);
};

export default function SandataMappingRow(
  props: SandataViewProps & {
    mapping: SandataPocMapping;
  }
) {
  const key = String(props.mapping.planOfCareItemId);
  const selected = props.draftMappings[key] ?? props.mapping.sandataPlanOfCareItemIds;
  const isDirty = !isSameSandataItemIds(selected, props.mapping.sandataPlanOfCareItemIds);
  const isSaving = props.savingPlanOfCareItemId === props.mapping.planOfCareItemId;
  // Flags what is saved, not the pending draft, so the marker reflects what Sandata sees today.
  const isUnmapped = props.mapping.sandataPlanOfCareItemIds.length === 0;

  return (
    <tr>
      <td>{props.mapping.section}</td>
      <td>
        {props.mapping.label}
        {isUnmapped && (
          <Tooltip label="Not mapped to a Sandata duty code">
            <span> {UNMAPPED_MARKER}</span>
          </Tooltip>
        )}
      </td>
      <td>{props.mapping.code}</td>
      <td>
        <Select
          searchable
          buttonProps={{ width: "100%" }}
          isDisabled={props.sandataItemOptions.length === 0}
          label="Sandata duty codes"
          multiple={true}
          options={props.sandataItemOptions}
          size="sm"
          value={selected.length > 0 ? selected : null}
          width="360px"
          onChange={(value) => props.onChangeDraftMapping(props.mapping.planOfCareItemId, value)}
        />
      </td>
      <td>
        <Button
          colorScheme="blue"
          isDisabled={!isDirty || isSaving}
          isLoading={isSaving}
          leftIcon={<CheckIcon />}
          size="sm"
          onClick={() => props.onSave(props.mapping, selected)}
        >
          Save
        </Button>
      </td>
    </tr>
  );
}
